<template>
	<step-by-step-guide-data-provider :initial-step-id="initialStepId" :step-ids="stepIdsArray" :api-url="apiUrl">
		<div slot-scope="dataProvider">
			<guide-steps
				:guide-steps="dataProvider.guideSteps"
				@fetchStep="dataProvider.fetchStep"
				></guide-steps>
			<div v-if="dataProvider.loading" class="c-spinner"></div>
		</div>
	</step-by-step-guide-data-provider>
</template>

<script>
import StepByStepGuideDataProvider from '@/components/step-by-step-guide/StepByStepGuideDataProvider.vue';
import GuideSteps from '@/components/step-by-step-guide/GuideSteps.vue';
export default {
    name: 'StepByStepGuide',
    props: {
		initialStepId: {
			type: String,
			default: ''
		},
        stepIds: {
            type: String,
            default: ''
        },
		apiUrl: {
			type: String,
			default: ''
		}
    },
    computed: {
        stepIdsArray() {
			if (this.stepIds) {
				return this.stepIds.split(',');
			} else {
				return [];
			}
		}
	},
    components: {
		StepByStepGuideDataProvider, GuideSteps
	},
    methods: {

    },
    created() {
    }
}
</script>
